import type { TFunction } from "i18next";
import type translations from "../../translations/translations.json";

type TranslationKeys = keyof typeof translations.en;

export interface ReportCardFinanceAction {
  id: string;
  label: string;
  testId: string;
  disabled: boolean;
  disabledHint: string;
  hidden?: boolean;
  onClick: () => void;
}

interface CreateReportCardFinanceActionsParams {
  t: TFunction;
  actionLoading: boolean;
  userCanApprove: boolean;
  canVerify: boolean;
  canRevise: boolean;
  canApprove: boolean;
  verifyDisabledHint: string;
  reviseDisabledHint: string;
  approveDisabledHint: string;
  onVerify: () => void;
  onRevise: () => void;
  onApprove: () => void;
  onApproveOverride: () => void;
  testIds: {
    verify: string;
    revise: string;
    approve: string;
    approveOverride: string;
  };
}

export const createReportCardFinanceActions = ({
  t,
  actionLoading,
  userCanApprove,
  canVerify,
  canRevise,
  canApprove,
  verifyDisabledHint,
  reviseDisabledHint,
  approveDisabledHint,
  onVerify,
  onRevise,
  onApprove,
  onApproveOverride,
  testIds,
}: CreateReportCardFinanceActionsParams): ReportCardFinanceAction[] => {
  const actions: ReportCardFinanceAction[] = [
    {
      id: "verify",
      label: t("orders.verify" as TranslationKeys),
      testId: testIds.verify,
      disabled: actionLoading || !canVerify,
      disabledHint: verifyDisabledHint,
      onClick: onVerify,
    },
    {
      id: "revise",
      label: t("orders.requestRevision" as TranslationKeys),
      testId: testIds.revise,
      disabled: actionLoading || !canRevise,
      disabledHint: reviseDisabledHint,
      onClick: onRevise,
    },
  ];

  if (userCanApprove) {
    actions.push(
      {
        id: "approve",
        label: t("orders.approve" as TranslationKeys),
        testId: testIds.approve,
        disabled: actionLoading || !canApprove,
        disabledHint: approveDisabledHint,
        onClick: onApprove,
      },
      {
        id: "approve-override",
        label: t("orders.approveWithOverride" as TranslationKeys),
        testId: testIds.approveOverride,
        disabled: actionLoading || !canApprove,
        disabledHint: approveDisabledHint,
        onClick: onApproveOverride,
      },
    );
  }

  return actions;
};
